import {Component, OnInit} from '@angular/core';
import {BaseWidgetComponent} from '../base-widget.component';
import {TabReportService} from '../../../_services/tab-report.service';
import {TabReportResult} from '../../../_models/report/tab-report-result';
import {ColumnFormatterService} from '../../../_services/column-formatter.service';

@Component({
    selector: 'bb-summary-list-widget',
    templateUrl: './summary-list-widget.component.html',
    styleUrls: ['./summary-list-widget.component.scss'],
})
export class SummaryListWidgetComponent extends BaseWidgetComponent implements OnInit {
    tabReportResult: TabReportResult;

    constructor(
        private tabReportService: TabReportService,
        columnFormatterService: ColumnFormatterService
    ) {
        super(columnFormatterService);
    }

    ngOnInit(): void {
    }

    refresh() {
        this.loading = true;
        this.tabReportService.runShell(this.getFilteredReport(), 0, 1, this.startDate, this.endDate, null, true)
            .subscribe((trr: TabReportResult) => {
                this.tabReportResult = trr;

                this.loading = false;
                this.error = false;
                this.dataReady.emit();
            }, () => {
                this.tabReportResult = null;
                this.loading = false;
                this.error = true;
            });
    }
}
